<template>
    <div class="FM_financial">
        <div style="margin-bottom: 20px;">
            <el-button size="small" icon="el-icon-back" @click="$router.back()">返 回</el-button>
        </div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="financeRecordForm" class="demo-form-inline">
                <el-form-item v-if="isedit==1">
                    <el-select
                        v-model="financeRecordForm.parent_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择归属机构"
                    >
                        <el-option
                            v-for="(item,index) in parentList"
                            :key="index"
                            :label="item.nickname"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isedit==1">
                    <el-select
                        size
                        v-model="financeRecordForm.income_type"
                        clearable
                        placeholder="请选择入账类型"
                    >
                        <el-option label="代理账户提现" value="2" v-if="financeRecordForm.account_type<3"></el-option>
                        <el-option label="伪激活扣款[提现]" value="3" v-if="financeRecordForm.account_type<3"></el-option>
                        <el-option label="未激活扣款[提现]" value="4" v-if="financeRecordForm.account_type<3"></el-option>
                        <el-option label="货款分期扣款[提现]" value="5" v-if="financeRecordForm.account_type<3"></el-option>
                        <el-option label="其他扣款[提现]" value="6" v-if="financeRecordForm.account_type<3"></el-option>
                        <el-option label="现金账户充值" value="2" v-if="financeRecordForm.account_type==3"></el-option>
                        <el-option label="收入充值" value="8" v-if="financeRecordForm.account_type==3"></el-option>
                        <el-option label="补充奖励充值" value="9" v-if="financeRecordForm.account_type==3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isedit==1">
                    <el-input
                        size
                        clearable
                        v-model="financeRecordForm.phone"
                        placeholder="请输入用户账号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="提现开始日期"
                        end-placeholder="提现结束日期"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerOptions"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(financeRecordForm)"
                    >查询</el-button>
                    <el-button v-if="isedit==1"
                        size="small"
                        type="primary"
                        icon="el-icon-download"
                        :loading="downLoading"
                        @click="handleDownLoad(financeRecordForm)"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <!-- <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-s-promotion" @click>占位</el-button>
            </div>-->
            <div style="margin-bottom: 10px;">
                <div class="tableTitle">
                    <span class="st-label">总金额：</span>
                    <span class="st-word-aux">{{ total_money }}</span>
                </div>
                <div class="tableTitle" v-if="financeRecordForm.account_type<3">
                    <span class="st-label">总税点：</span>
                    <span class="st-word-aux">{{ tax_point }}</span>
                </div>
                <div class="tableTitle" v-if="financeRecordForm.account_type<3">
                    <span class="st-label">总手续费：</span>
                    <span class="st-word-aux">{{ tax_fee }}</span>
                </div>
            </div>
            <el-table
                :data="financeRecordTable"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <el-table-column v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="50"
                ></el-table-column>
                <!-- 交易类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status"
                    label="状态"
                    min-width="100"
                ></el-table-column>
                <!-- 交易类型 -->
                <el-table-column v-if="isedit==1 && financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="second"
                    label="所属机构"
                    min-width="180"
                >
                <template slot-scope="scope">
                    <p v-html="scope.row.second"></p>
                </template>
                </el-table-column>
                <el-table-column  v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="first"
                    label="提现代理"
                    min-width="200"
                >
                <template slot-scope="scope">
                    <p v-html="scope.row.first"></p>
                </template>
                </el-table-column>
                <!-- 用户名称 -->
                <el-table-column  v-if="financeRecordForm.account_type==3"
                    header-align="center"
                    align="center"
                    prop="type"
                    label="充值渠道"
                    min-width="120"
                ></el-table-column>
                <!-- 用户名称 -->
                <el-table-column  v-if="financeRecordForm.account_type==3"
                    header-align="center"
                    align="center"
                    prop="money"
                    label="充值金额"
                    min-width="120"
                ></el-table-column>
                <!-- 用户账户 -->
                <el-table-column v-if="financeRecordForm.account_type==3"
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="充值时间"
                    min-width="150"
                ></el-table-column>
                <!-- 来源 -->
                <!-- <el-table-column  v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="audit_time"
                    label="审核时间"
                    min-width="250"
                ></el-table-column> -->
                <!-- 金额 -->
                <el-table-column  v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="tax_point"
                    label="税点"
                    min-width="120"
                ></el-table-column>
                <!-- 入账时间 -->
                <el-table-column  v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="service_fee"
                    label="手续费"
                    min-width="100"
                ></el-table-column>
                <!-- 用户名称 -->
                <el-table-column  v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="money"
                    label="提现金额"
                    min-width="100"
                ></el-table-column>
                <!-- 用户账户 -->
                <el-table-column v-if="financeRecordForm.account_type<3"
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="提现时间"
                    min-width="180"
                ></el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "FM_agentoutaccountList",
    data() {
        return {
            isedit: sessionStorage.getItem('level'), //等级
            account_type: this.$route.query.account_type,
            currentDate: '',
            pickerOptions: {},
            rangeDate: [], //时间范围
            financeRecordTable: [], //表格
            parentList: [], //终端类型
            financeRecordForm: {
                // real_name: '', //用户名称
                phone: '', //用户账户
                start_create_time: '',    //申请开始时间
                end_create_time: '',    //申请结束时间
                account_type: this.$route.query.account_type,
                parent_id: '', //终端类型
                income_type:'2',
                page: 1,
                limit: 10
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false, //导出loading
            total_money: 0,//总金额
            tax_point: 0,//总税点
            tax_fee: 0,//总手续费
        }
    },
    mounted() {
        this.getData(this.financeRecordForm);
        this.getParent();//获取终端类型
    },
    components: {
        paginations
    },
    methods: {
        onSearch(financeRecordForm) {
            this.page.currentPage = 1;
            this.financeRecordForm.page = 1;
            // 表单提交
            this.getData(financeRecordForm);
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = this.page.pageSize;
            this.getData(this.financeRecordForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.financeRecordForm.page = this.page.currentPage;
            this.financeRecordForm.limit = limit;
            this.getData(this.financeRecordForm);
        },
        getData(params) {
            this.$api.post("user/balance_log_outlist", params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.financeRecordTable = data.list;
                this.total_money = Number(data.totalmoney/100).toFixed(2);
                this.tax_point = Number(data.tax)
                this.tax_fee = Number(data.service_fee/100);
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        getParent() { //获取终端类型
            this.$api.post('user/list_by_id', {}, res => {
                if (res.code == 0) {
                    this.parentList = res.data.list;
                } else {
                    this.$message.success(res.msg);
                }
            });
        },
        handleDownLoad(financeRecordForm) { //导出
            // var diffdate=(new Date(financeRecordForm.end_create_time).getTime() / 1000 - new Date(financeRecordForm.start_create_time).getTime() / 1000)/3600/24;
            // if(diffdate>1 && financeRecordForm.type==11){
            //     this.$message.error("限制导出单天数据");
            // }else{
                this.downLoading = true;
                this.$api.post("user/balance_log_outlist_download", financeRecordForm, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        var link=this.$file_url+res.data;
                        window.open(link)
                    } else {
                        this.$message.error(res.msg);
                    }
                    //渲染结束后取消加载
                    this.downLoading = false;
                });
            // }
        },
        pickerChange(DateArr) { //时间选择器
            this.financeRecordForm.start_create_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.financeRecordForm.end_create_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
    }
};
</script>

<style lang="scss" scope>
.FM_financial {
    .realTitle {
        :nth-child(1) {
            font-size: 12px;
            font-weight: 700;
            color: #1e1e1e;
        }
        .imgParent {
            margin: 10px 0;
            // width: 500px;
            overflow: hidden;
            img {
                width: 100%;
                height: 250px;
                border-radius: 10px;
            }
        }
    }
    .el-dialog__header {
        padding: 20px 20px 0px;
    }
    .el-dialog__body {
        padding: 0px 20px 30px 20px;
    }
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
    .tableTitle {
        display: inline-block;
        margin-right: 20px;
    }
}
</style>
